import api from 'js/api'
export const getUserProfile = () =>
  Promise.all([
    api('GET', 'userprofile/v3/me', undefined, { cache: 'no-store' }),
    api('GET', 'v2/store/subscription'),
  ]).then(([profile, { response }]) => ({ ...profile, ...response }))
